import React, { ReactNode } from "react";

type FilterWrapTypes = {
  children?: ReactNode;
  classNames?: string;
};

const PageContainer = ({ children, classNames }: FilterWrapTypes) => {
  return <div className={`page-container ${classNames ?? ""}`}>{children}</div>;
};
export default PageContainer;
